import * as React from 'react'
import { type ProductSearchParams } from '../components/search/utils/types'
import { trackEvent } from '../../../utils/events/trackEvent'
import { parseCreationDate, parseSearchTerm, validQuery } from './getRetailerProductsMesh.hooks'
import {
  type GetRetailerProductsMeshQueryVariables,
  type InstacartCustomersSharedV1Locale,
} from './index'

const useGetRetailerProductsVariables = (props: ProductSearchParams) => {
  const {
    departmentId,
    aisleId,
    page,
    locale,
    retailerId,
    hasPrimaryImageUrl,
    isStoreBrandProduct,
    limit,
  } = props

  const offsetValue = limit * (page - 1)

  const result: GetRetailerProductsMeshQueryVariables = {
    retailerId: retailerId,
    limit: limit?.toString(),
    offset: offsetValue.toString(),
    aisleIds: aisleId ? [aisleId.toString()] : undefined,
    departmentIds: departmentId ? [departmentId.toString()] : undefined,
    localeCode: locale.toUpperCase() as InstacartCustomersSharedV1Locale,
    hasPrimaryImageUrl: hasPrimaryImageUrl,
    isStoreBrandProduct: isStoreBrandProduct,
    productCreationDateRange: parseCreationDate(props),
    ...parseSearchTerm(props),
  }

  const validationCheck = validQuery(props)
  const skip = !validationCheck.isValid
  const searchError = validationCheck.searchError

  trackEvent({
    id: 'products.products_search.search_event',
    description: 'Tracks individual search events',
    data: {
      retailerId,
      limit,
      locale,
      departmentId,
      aisleId,
      /** TODO: eventually add ProductCreatedAtFilter */
      hasPrimaryImageUrl,
      isStoreBrandProduct,
    },
  })

  return { result, skip, searchError }
}

export default useGetRetailerProductsVariables
